import { z } from 'zod';
import { ZodBaseWidgetConfiguration, ZodGenericWidgetConfigurationDetails } from '../types';
import { WidgetType } from '../types';
import {
    zMarshalToBoolean,
    zMarshalToNumber,
    zMarshalToStrictInt,
} from '../../ReachApi/Marshallers';

export const ZodMapsWidgetConfigurationDetails = ZodGenericWidgetConfigurationDetails.extend({
    key: z.string(),
    lat: z.union([z.string(), z.number()]).transform(zMarshalToNumber),
    lng: z.union([z.string(), z.number()]).transform(zMarshalToNumber),
    zoom: z.union([z.string(), z.number()]).transform(zMarshalToStrictInt),
    showTraffic: z.unknown().transform(zMarshalToBoolean),
    mapType: z.string().nullish(),

    // TODO: Should be using enum, but cannot today
    // mapType: z.nativeEnum(MapTypeId).optional(), //Default is MapTypeId.ROADMAP
});

export type MapsWidgetConfigurationDetails = z.infer<typeof ZodMapsWidgetConfigurationDetails>;

export const ZodMapsWidgetConfiguration = ZodBaseWidgetConfiguration.extend({
    type: z.literal(WidgetType.MAPS),
    config: ZodMapsWidgetConfigurationDetails,
});

export type MapsWidgetConfiguration = z.infer<typeof ZodMapsWidgetConfiguration>;

/**
 * @todo: See comment on ZodMapsWidgetConfigurationDetails.mapType
 * @see {google.maps.MapTypeId}
 */
export enum MapTypeId {
    HYBRID = 'hybrid',
    ROADMAP = 'roadmap',
    SATELLITE = 'satellite',
    TERRAIN = 'terrain',
}
